import {
  Button,
  Card,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useEffect, useState } from "react";
import Style from "../../styles/login.module.scss";
import { Link, useNavigate } from "react-router-dom";
import SnackUI from "../../common/SnackUI";
import { useDispatch, useSelector } from "react-redux";
import { registerUserAction } from "../../redux/toolkit/auth/registerUser";
import { resetPasswordAction } from "../../redux/toolkit/auth/resetPassword";
import Welcome from "../../assets/img/forgotpassword.png";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
import Visibility from "../../assets/img/eye-closed.png";
import VisibilityOff from "../../assets/img/eye.png";
import Blur from "../../assets/img/blur.png";
import Popup from "./Popup";
import dashboardImg from "../../assets/img/Dashboard.png";

const NewChangePassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [password, setPassword] = useState("");
  const [cpassword, setCPassword] = useState("");
  const [snack, setSnack] = useState(false);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);

  const [validPassword, setValidPassword] = useState(true);
  const [validCPassword, setValidCPassword] = useState(true);

  const registerSelector = useSelector((state) => state.resetpassword);
  const { message, status, loading } = registerSelector;

  const [isPassWordMatch, setIsPassWordMatch] = useState(true);

  console.log("password change", password, cpassword);

  function validatePassword(password) {
    setIsPassWordMatch(true);
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    return regex.test(password);
  }

  function validatePassword(password) {
    setIsPassWordMatch(true);
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    return regex.test(password);
  }

  const changePasswordHandler = async (e) => {
    e.preventDefault();
    if (!password || !cpassword) {
      setValidPassword(false);
      setValidCPassword(false);
      return;
    }

    if (password !== cpassword) {
      setIsPassWordMatch(false);
      return;
    }

    const registerData = await dispatch(
      resetPasswordAction({ password: password, cpassword: cpassword })
    );
    setSnack(true);
  };

  const showPassword = () => {
    setShow(!show);
  };
  const showPassword2 = () => {
    setShow2(!show2);
  };

  useEffect(() => {
    if (password) {
      const isValid = validatePassword(password);
      if (!isValid) {
        setValidPassword(false);
      } else {
        setValidPassword(true);
      }
    }
  }, [password]);

  useEffect(() => {
    if (cpassword) {
      const isValid = validatePassword(cpassword);
      if (!isValid) {
        setValidCPassword(false);
      } else {
        setValidCPassword(true);
      }
    }
  }, [cpassword]);

  return (
    <>
      <div className="container">
        <div className="header">
          {/* <div className="left-header">
            <p>Real Opinion</p>
          </div>
          <div className="right-header">
            <p>
              Already a user ?
              <button onClick={() => navigate("/login")}>Login</button>
            </p>
          </div> */}
        </div>

        <div className="form-image-container">
          <div className="form-container">
            <div className="form-header">
              {/* <p className="p1">welcome</p> */}
              <p className="p3">Forgot password?</p>
              <p className="p2">Don’t worry. We can help.</p>
            </div>

            <div className="form">
              <div className="form-fields">
                <form onSubmit={changePasswordHandler} className="spacey4">
                  <div className="field-wrap">
                    <label htmlFor="password">Enter New Password</label>
                    <div
                      style={{
                        width: "100%",
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      <input
                        style={{ width: "100%" }}
                        type={show ? "text" : "password"}
                        name="password"
                        placeholder="Enter your Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />

                      <span
                        style={{
                          position: "absolute",
                          top: "6px",
                          right: "10px",
                          cursor: "pointer",
                        }}
                        onClick={showPassword}
                      >
                        {show ? (
                          <img src={VisibilityOff} width="23px" />
                        ) : (
                          <img src={Visibility} width="23px" />
                        )}
                      </span>
                    </div>
                    {!validPassword && (
                      <p style={{ color: "red", fontSize: 12 }}>
                        Password must be at least 8 characters long and contain
                        at least one uppercase letter, one lowercase letter, and
                        one number
                      </p>
                    )}
                  </div>

                  <div className="field-wrap">
                    <label htmlFor="confirmPassword">Confirm Password</label>
                    <div
                      style={{
                        width: "100%",
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      <input
                        style={{ width: "100%" }}
                        type={show2 ? "text" : "password"}
                        name="confirmPassword"
                        placeholder="Confirm your Password"
                        value={cpassword}
                        onChange={(e) => setCPassword(e.target.value)}
                      />

                      <span
                        style={{
                          position: "absolute",
                          top: "6px",
                          right: "10px",
                          cursor: "pointer",
                        }}
                        onClick={showPassword2}
                      >
                        {show2 ? (
                          <img src={VisibilityOff} width="23px" />
                        ) : (
                          <img src={Visibility} width="23px" />
                        )}
                      </span>
                    </div>
                  </div>

                  {/* <div className="field-wrap">
                    <label htmlFor="mobile">Phone Number</label>
                    <input
                      type="tel"
                      name="mobile"
                      placeholder="Enter your phone number"
                     
                    />
                  </div> */}

                  <button
                    disabled={password && cpassword ? false : true}
                    type="submit"
                    className="form-button"
                    onClick={changePasswordHandler}
                  >
                    Save Password
                  </button>
                  {!isPassWordMatch && (
                    <p style={{ color: "red", fontSize: 12 }}>
                      Passwords do not match
                    </p>
                  )}

                  <Stack>
                    <Typography
                      marginTop="18%"
                      color="#585858"
                      fontFamily="lato"
                      fontSize="21px"
                      variant="subtitle2"
                      align="right"
                    >{`Remembered your Password?`}</Typography>

                    <Typography
                      variant="h6"
                      sx={{ color: "rgba(142, 45, 226, 1)", fontSize: "1.8em" }}
                      align="right"
                      disabled={loading}
                    >
                      <Link
                        style={{ textDecoration: "none", width: "100%" }}
                        to="/login"
                      >
                        {loading ? <CircularProgress /> : "Back To Login"}
                      </Link>
                    </Typography>
                  </Stack>
                </form>
              </div>
            </div>
          </div>

          <div className="img-container">
            <img src={dashboardImg} alt="" />
          </div>
        </div>

        <div className="footer">
          <p>2025 Real Opinion | All Rights Reserved</p>
        </div>
      </div>
      {snack && <Popup state={snack} setState={setSnack} btn="Continue" />}
    </>
  );
};

export default NewChangePassword;
